function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';

var AnimatedIcon = function AnimatedIcon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, ["name", "className"]);

  var classes = classNames('icon is-stacked is-animated has-text-centered', className);
  return React.createElement("span", _extends({
    className: classes,
    "aria-hidden": "true"
  }, others), React.createElement("i", {
    className: "tri-".concat(name, "_top tri-animated")
  }), React.createElement("i", {
    className: "tri-".concat(name, "_bottom tri-animated")
  }));
};

AnimatedIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default withModifiers(AnimatedIcon);